import React from "react";
import { connect } from "react-redux";
import { Router, Route, withRouter, Redirect } from "react-router";
import { detect } from "detect-browser";
import LandingPage from "./containers/LandingPage";
import Diner from "./containers/Diner";
import BookingDetails from "./containers/booking-details";
import Chef from "./containers/Chef";
import Login from "./components/Login";
import HomePage from "./containers/HomePage";
import ChefSetup from "./containers/ChefSetup";
import ChefProfile from "./containers/Chef/Profile";

import Blog from "./containers/Blog";
import AddDish from "./components/Dishes/AddDish";
import DishSearch from "./components/Dishes/Dishes";
import ChefPortfolio from "./containers/Chef/Portfolio";
import ChefSearch from "./containers/Chef/Listing";
import ChefSchedule from "./containers/Chef/Schedule";
import ChefDetails from "./components/Chefs/ChefDetailsDiner";
import ChefPublicProfile from './containers/Chef/PublicChef';
import ChefBooking from "./containers/Chef/Booking";
import ChefBookings from "./containers/Chef/Bookings";
import EditPortfolio from "./containers/Chef/EditPortfolio";
import AboutUs from "./components/TermsPolicy/AboutUs";
import AddPost from "./components/Posts/AddPosts";
import PostSearch from "./components/Posts/Posts";
// import DishDetails from "./components/Dishes/DishDetails";
import DishDetails from "./containers/Dish-Details";
import PostDetails from "./components/Posts/PostDetails";
import PublicPosts from "./containers/Chef/PublicPosts";
import SavedData from "./containers/SavedData";
import DinerBookingStatus from "./containers/Diner/DinerBookingStatus";
import DinerBookings from "./containers/Diner/Bookings";
/*import Inbox from "./containers/Inbox";
import DinerInbox from "./containers/Inbox";*/
import Review from "./components/Review/Review";
import UserReview from "./components/Review/UserReview";
import RaiseDispute from "./components/Booking/RaiseDispute";
import UnAuthorized from "./containers/Others/UnAuthorized";
import Privacy from "./components/TermsPolicy/PrivacyPolicy";
import TermsConditions from "./components/TermsPolicy/TermsConditions";
import TermsConditionsMobile from "./components/TermsPolicy/TermsConditionsMobile";
import ScrollToTopOnMount from "./ScrollToTopOnMount";
import SubscriptionPage from "./containers/ChefSetup/subscription";
import LoginPage from "./containers/LandingPage/Login";
import RegisterPage from "./containers/LandingPage/SignUp";
import ForgotPasswordPage from "./containers/LandingPage/ForgotPassword";
import DishDetailPage from "./components/Dishes/DishDetailPage";
import PrivacyPolicyMobile from "./components/TermsPolicy/PrivacyPolicyMobile";
import ReviewBooking from "./containers/ReviewBooking";

class Index extends React.Component {
  getBrowserList = os => {
    switch (os) {
      default:
        return (
          <ul>
            <li>Latest Chrome</li>
            <li>Latest Firefox</li>
            <li>Latest Safari</li>
          </ul>
        );

      case 'Mac OS':
        return (
          <ul>
            <li>Latest Chrome</li>
            <li>Latest Firefox</li>
            <li>Latest Safari</li>
          </ul>
        );

      case 'Windows':
        return (
          <ul>
            <li>Latest Chrome</li>
            <li>Latest Firefox</li>
            <li>Latest Edge</li>
          </ul>
        );
    }
  };

  isSupportedBrowser = () => {
    const browser = detect();

    switch (browser && browser.name) {
      case 'chrome':
      case 'firefox':
      case 'safari':
      case 'edge':
      case 'crios':
      case 'ios':
        return "";

      default:
        return browser.os;
    }
  };

  render() {
    const { history: { location } }= this.props;
    let checkOs = true;
    if (location.pathname) {
      switch (location.pathname) {
        default:
          checkOs = true;
          break;

        case '/mobile/privacy-policy':
        case '/mobile/terms-of-use':
        case '/about-us':
          checkOs = false;
          break;
      }
    }

    if (checkOs) {
      const os = this.isSupportedBrowser();
      if (os !== "") {
        return (
            <div>
              <h4>This browser is not supported. Please access this website using any of the following browsers</h4>
              {this.getBrowserList(os)}
            </div>
        );
      }
    }

    return (
      <div>
        <Router history={this.props.history}>
          <ScrollToTopOnMount>
          <div>
            <Route path="/chef/profile/:slug" component={ChefPublicProfile} />
            <Route path="/post/:slug" component={PublicPosts} />
            <Route path="/dish/:slug" component={DishDetails} />
            <Route exact path="/" component={LandingPage} />
            <Route exact path="/unauthorized" component={UnAuthorized} />
            <Route exact path="/diner" component={Diner} />
            <Route exact path="/chef" component={Chef} />
            <Route exact path="/iamin" component={Diner} />
            <Route exact path="/hellochef" component={Chef} />
            <Route exact path="/iamchef" component={Chef} />
            <Route path="/login" component={Login} />
            <Route path="/blog" component={Blog} />
            <Route path="/home/dashboard" component={HomePage} />
            <Route path="/sign-in" component={LoginPage} />
            <Route path="/sign-up" component={RegisterPage} />
            <Route path="/sign-up-chef" component={RegisterPage} />
            <Route path="/forgot-password" component={ForgotPasswordPage} />
            <Route path="/home/become-chef" component={ChefSetup} />
            <Route path="/home/subscription" component={SubscriptionPage} />
            <Route path="/home/add-dish" component={AddDish} />
            <Route path="/home/saved" component={SavedData} />
            <Route
              path="/home/chef-portfolio"
              render={props => <ChefPortfolio key={Date.now()} {...props} />}
            />
            <Route path="/home/chef-search" component={ChefSearch} />
            <Route path="/home/chef-schedule" component={ChefSchedule} />
            <Route path="/home/edit-portfolio" component={EditPortfolio} />

            <Route path="/home/post-search" component={PostSearch} />
            <Route path="/home/dish-search" component={DishSearch} />
            <Route path="/home/add-post" component={AddPost} />
            <Route
              path="/home/dish-details"
              render={props => <DishDetailPage key={Date.now()} {...props} />}
            />
            <Route path="/home/post-details" component={PostDetails} />
            <Route path="/home/chef-profile" component={ChefDetails} />
            <Route path="/home/chef-booking" component={ChefBooking} />
            <Route path="/home/chef-bookings" component={ChefBookings} />
            <Route
              path="/home/chef-booking-status"
              component={DinerBookingStatus}
            />
            {/*<Route path="/profile" component={ChefProfile} />*/}
            <Route path="/home/profile/edit-profile" exact component={ChefProfile} />
            <Route path="/home/profile/my-kitchen" exact component={ChefProfile} />
            <Route path="/home/profile/payment-info" component={ChefProfile} />
            <Route path="/home/profile/chef-payment-info" component={ChefProfile} />
            <Route path="/home/profile/equipments" component={ChefProfile} />
            <Route path="/home/profile/invite-friends" component={ChefProfile} />
            <Route path="/home/profile/get-help" component={ChefProfile} />
            <Route path="/home/profile/feedback" component={ChefProfile} />
            <Route path="/home/profile/booking/:type/:booking" component={ChefProfile} />
            <Route path="/home/profile/verified-chef" component={ChefProfile} />
            <Route path="/home/profile/become-verified-chef" component={ChefProfile} />
            <Route path="/home/profile/accounting" component={ChefProfile} />
            <Route path="/home/profile/subscription" component={ChefProfile} />
            <Route path="/home/profile/cancelation-policy" component={ChefProfile} />
            <Route
              path="/home/diner-booking-status"
              component={DinerBookingStatus}
            />
            <Route exact path="/home/diner-bookings" component={DinerBookings} />
            {/*<Route path="/home/inbox" component={Inbox} />*/}
            <Route path="/home/booking-details/:bookingId" component={BookingDetails} />
            {/*<Route path="/home/diner-inbox" component={DinerInbox} />*/}
            <Route path="/home/review" component={Review} />
            <Route path="/home/user-review" component={UserReview} />
            <Route path="/home/raise-dispute" component={RaiseDispute} />
            <Route path="/home/privacy-policy" component={Privacy} />
            <Route path="/mobile/privacy-policy" component={PrivacyPolicyMobile} />
            <Route path="/home/terms-of-use" component={TermsConditions} />
            <Route path="/mobile/terms-of-use" component={TermsConditionsMobile} />
            <Route path="/home/about-us" component={AboutUs} />
            <Route path="/booking/review" component={ReviewBooking} />
          </div>
          </ScrollToTopOnMount>
        </Router>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const Main = connect(mapStateToProps)(Index);

export default Main;
